import { render, staticRenderFns } from "./DetailPayAuthoriry.vue?vue&type=template&id=29fcdbef"
import script from "./DetailPayAuthoriry.vue?vue&type=script&lang=ts"
export * from "./DetailPayAuthoriry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports